// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2nBhP","empty":"ModalGraph_empty__QZPqU"};